var map = {
	"./applestore.png": "0c86",
	"./bg.png": "d68e",
	"./googleplay.png": "2c78",
	"./jimber-vault.png": "fffe",
	"./jimber.png": "5c95a",
	"./truncus-vault.png": "5e69",
	"./truncus.png": "c50c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";